import Vue from 'vue';
import Declarer from './Declarer.vue';

new Vue({
    el: '#declarer-page',
    render: (h) => h(Declarer)
});


// WEBPACK FOOTER //
// ./Scripts/app/sts/declarers/declarer/index.js